import { MIN_VIEW_SCALE } from '../constants';

/**
 * Every size, hit radius and stroke weight used by the canvas handles, in screen
 * pixels. Multiply through `screenPx`/`worldPx` in ./handleScale to turn these into
 * viewBox user units.
 */

/**
 * Handle sizes are clamped to this range before being converted to user units, so
 * they stop shrinking when fully zoomed in and stop growing when zoomed out.
 */
export const HANDLE_SCALE_MIN = MIN_VIEW_SCALE;
export const HANDLE_SCALE_MAX = 1.2;

/** Side of the square resize handles (element corners, polyline vertices, multiselect). */
export const SQUARE_HANDLE_SIZE_PX = 8;
/** Radius of the round handles (triangle apex, corner radius). */
export const ROUND_HANDLE_RADIUS_PX = 5;
/** Side of the split ("insert point") button. Deliberately larger than a resize handle. */
export const SPLIT_HANDLE_SIZE_PX = 10;
/** Diameter of the circular rotate / edit-text buttons. */
export const ROTATE_HANDLE_SIZE_PX = 24;

/**
 * Outline weight of a handle. Expressed in screen px so it stays visually constant at
 * every zoom level; the value is `0.5 / HANDLE_SCALE_MAX` so the default view renders
 * exactly as it did when the stroke was a fixed 0.5 user units.
 */
export const HANDLE_STROKE_WIDTH_PX = 0.5 / HANDLE_SCALE_MAX;
/** Same idea for the split button and its "+" icon, which draw a lighter 0.2 outline. */
export const SPLIT_STROKE_WIDTH_PX = 1 / HANDLE_SCALE_MAX;

/** Half-length of each arm of the split button's "+" icon, as a fraction of half the button. */
export const SPLIT_ICON_ARM_RATIO = 0.5;

/** Invisible hit targets, which are larger than the visible handle. */
export const HANDLE_HIT_RADIUS_PX = 14;
export const RADIUS_HANDLE_HOVER_RADIUS_PX = 16;
export const SPLIT_HIT_STROKE_PX = 16;
/** Thickness of the invisible edge-resize strips along a shape's sides. */
export const EDGE_STRIP_THICKNESS_PX = 12;

/** How far from the corner a radius handle sits when the radius is 0. */
export const MIN_RADIUS_HANDLE_OFFSET_PX = 12;
/** Half-length of the tics capping each end of the radius rail. */
export const RADIUS_RAIL_TIC_HALF_LENGTH_PX = 4;
export const RADIUS_LABEL_OFFSET_PX = 10;
export const RADIUS_LABEL_FONT_SIZE_PX = 14;
